import qs from 'qs';
import { fetchJson } from '@zapier/toolbox-browser-fetch';
import type { Service } from '@zapier/services/src/types';

type FetchServices = () => Promise<Service[]>;

interface ImplementationsMeta {
  count: number;
  previous: string | null;
  next: string | null;
  results: Service[];
}

const fetchPublicServices: FetchServices = async () => {
  const url = '/api/v4/implementations-meta/public';
  const { results }: ImplementationsMeta = await fetchJson(url);
  return results;
};

const fetchPrivateServices: FetchServices = async (nextUrl: string | null) => {
  const queryString = qs.stringify({
    limit: 500,
  });
  const url = nextUrl || `/api/v4/implementations-meta/private?${queryString}`;
  return await fetchJson(url);
};

type OnReceiveServices = (services: {
  publicServices: Service[];
  privateServices: Service[];
}) => void;
type LoadServices = (
  onReceiveServices: OnReceiveServices,
  url?: string | null
) => Promise<void>;

export const loadPrivateServices: LoadServices = async (
  onReceivePrivateServices,
  url
) => {
  const privateServicesData = await fetchPrivateServices(url);
  onReceivePrivateServices(privateServicesData);
};

export const loadPublicServices: LoadServices = async onReceivePublicServices => {
  const publicServices = await fetchPublicServices();
  onReceivePublicServices(publicServices);
};
